interface IColor { 
	[key: string]: string
}

export const backgroundColors:IColor = {
	'day-overcast': 'rgb(151, 155, 161)', 
	'day-clear': 'rgb(65, 106, 218)',
	'evening-overcast': 'rgb(171, 161, 157)',
	'evening-clear': 'rgb(104, 114, 142)',
	'night-clear': 'rgb(27, 34, 54)',
	'night-overcast': 'rgb(27, 34, 54)',
}

export const HillsColors1:IColor = {
	'winter-day-overcast': 'rgb(240, 240, 240)', 
	'winter-day-clear': 'rgb(240, 240, 240)',
	'winter-evening-overcast': 'rgb(77, 77, 77)',
	// 'winter-evening-clear': 'rgb(77, 77, 77)',
	'winter-night-clear': 'rgb(39, 49, 77)',
	'winter-night-overcast': 'rgb(39, 49, 77)',
	'summer-morning-overcast': 'rgb(150, 170, 160)',
	'summer-morning-clear': 'rgb(149, 203, 176)',
	'summer-day-clear': 'rgb(26, 134, 76)',
	'summer-day-overcast': 'rgb(39, 49, 77)',
	'summer-evening-clear': 'rgb(124, 170, 147)',
	'summer-evening-overcast': 'rgb(150, 170, 160)',
	'summer-night-overcast': 'rgb(39, 49, 77)',
	'summer-night-clear': 'rgb(39, 49, 77)'
}

export const HillsColors2:IColor = {
	'winter-day-overcast': 'rgb(250, 250, 250)',
	'winter-day-clear': 'rgb(250, 250, 250)',
	'winter-evening-overcast': 'rgb(136, 132, 132)',
	// 'winter-evening-clear': 'rgb(77, 77, 77)',
	'winter-night-clear': 'rgb(50, 60, 91)',
	'winter-night-overcast': 'rgb(50, 60, 91)',
	'summer-morning-overcast': 'rgb(150, 180, 150)',
	'summer-morning-clear': 'rgb(156, 212, 156)',
	'summer-day-clear': 'rgb(70, 207, 134)',
	'summer-day-overcast': 'rgb(50, 60, 91)',
	'summer-evening-clear': 'rgb(135, 195, 135)',
	'summer-evening-overcast': 'rgb(150, 180, 150)',
	'summer-night-overcast': 'rgb(50, 60, 91)',
	'summer-night-clear': 'rgb(50, 60, 91)',
}